import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatTableModule, MatRowDef } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import CompanyAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company.entity";
import { CompanyService } from "../company/company.service.service";
import { MatTabsModule } from "@angular/material/tabs";
import { NgSelectComponent, NgSelectModule } from "@ng-select/ng-select";
import SalesOrganizationAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-organization/sales-organization.entity";
import { SalesOrganizationService } from "../sales-organization/sales-organization.component.service";
import { ICreateDivision } from "./interfaces/create-division.interface";
import { DivisionService } from "./division.service.service";
import DivisionAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/division/division.entity";
import { IUpdateDivision } from "./interfaces/update-division.interface";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { getCode } from "app/utils/method";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { Subscription } from "rxjs";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { IFilters } from "../../filters/interfaces/filterInterface";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";

@Component({
  selector: 'app-division',
  standalone: true,
  templateUrl: './division.component.html',
  styleUrl: './division.component.scss',
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectComponent,
    NgSelectModule,
    MatTabsModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
})
export class DivisionComponent implements AfterViewInit, OnDestroy{
  getCode = getCode;

  displayedColumns: string[] = ["name","company", "salesOrganization", "status", "actions"];
  currentCreateDivision: ICreateDivision = this.initializeCreateDivision();
  currentUpdateDivision: DivisionAttributes | undefined;

  dataSource: DivisionAttributes[] = [];
  companyList: CompanyAttributes[] = [];
  salesOrganizationList: SalesOrganizationAttributes[] = [];
  selectedCompanyIds: string[] = [];
  searchQuery: string = "";
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 0;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;
  
  //BUSCADOR
  searchSubscription: Subscription;

  selectedStatuses: number[] = [];
  form: FormGroup;

  // Lazy loading
  loadFiltersData = false;
  private companiesLoaded = false;
  private dataLoadedForModals = false;

  constructor(
    private readonly divisionService: DivisionService,
    private readonly salesOrganizationService: SalesOrganizationService,
    private readonly companyService: CompanyService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      companyId: []
    });
  }
  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  private ensureCompaniesLoaded(): void {
    if (!this.companiesLoaded) {
      this.fetchCompanies();
    }
  }

  private ensureModalDataLoaded(): void {
    if (!this.dataLoadedForModals) {
      this.initializeComboBox();
      this.dataLoadedForModals = true;
    }
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
    this.ensureCompaniesLoaded();
  }

  private initializeCreateDivision(): ICreateDivision {
    return {
      name: "",
      companyId: "",
      salesOrganizationId: "",
    };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }
  getSelectedCompanyCodes(selectedCompanyIds: string[]): number[] {
    return selectedCompanyIds.map(
      (id) => this.companyList.find((group) => group._id.toString() === id)?.id
    );
  }

  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction === "asc" ? "ASC" : "DESC";
      // const companyCodes = this.getSelectedCompanyCodes(this.selectedCompanyIds);
      let filter: IFilters = {
        companyId: this.form.get("companyId")?.value,
        status: this.selectedStatuses.length > 0 ? this.selectedStatuses : undefined
      };

    this.divisionService
      .findAllWithCount({
        currentPage: pageIndex,
        limitPerPage: this.pageSize,
        search: this.searchQuery,
        sort: sortField,
        sortDirection: sortDirection,
      },
      filter
    )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof DivisionAttributes {
    const validSortFields: (keyof DivisionAttributes)[] = ["name", "statusId"];
    return validSortFields.includes(
      this.sort.active as keyof DivisionAttributes
    )
      ? (this.sort.active as keyof DivisionAttributes)
      : "name";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }

  trackByFn(index: number, item: DivisionAttributes): string {
    return item._id.toString();
  }

  initializeComboBox(){
    this.fetchCompanies();
    this.fetchAllSalesOrganization();
  }

  private fetchAllSalesOrganization(): void {
    this.salesOrganizationService.findToComboBox().subscribe({
      next: (res) => {
        this.salesOrganizationList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener organizaciones de venta.","Cerrar",{ duration: 5000});
      },
    });
  }


  private fetchCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      this.companyList = res.data;
      this.companiesLoaded = true;
    });
  }


  openCreateModal(): void {
    this.ensureModalDataLoaded();
    this.currentCreateDivision = this.initializeCreateDivision();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose:true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createDivision());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(warehouse: DivisionAttributes): void {
    this.ensureModalDataLoaded();
    this.currentUpdateDivision = { ...warehouse };
    this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose:true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateDivision(warehouse._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createDivision(): void {
    this.divisionService.create(this.currentCreateDivision).subscribe({
      next: () => {
        this.snackBar.open("Registro creado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.findAllWithCount();
        this.dialogRefAdd.close(true);
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al crear el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  updateDivision(id: string): void {
    if (this.currentUpdateDivision) {
      const updatedDivision: IUpdateDivision = {
        ...this.currentUpdateDivision,
        companyId: this.currentUpdateDivision.company._id.toString(),
        salesOrganizationId: this.currentUpdateDivision.salesOrganization._id.toString(),
      };
      this.divisionService.update(id, updatedDivision).subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
          this.dialogRefEdit.close(true);
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
    }
  }

  onStatusChange(event: boolean, warehouse: DivisionAttributes): void {
    const originalStatusId = warehouse.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedDivision = { ...warehouse, statusId: updatedStatusId };

    this.divisionService
      .update(warehouse._id.toString(), updatedDivision)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          warehouse.statusId = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  openDeleteDialog(warehouse: DivisionAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: warehouse, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(warehouse._id.toString()));
  }

  delete(id: string): void {
    this.divisionService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    });
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  

  onCompanySelectionChange(companyid: string): void {
    if (this.currentUpdateDivision) {
      this.currentUpdateDivision.company = this.companyList.find(
        (price) => price._id.toString() === companyid
      )!;
    }
  }

  onSalesOrganizationSelectionChange(salesId: string): void {
    if (this.currentUpdateDivision) {
      this.currentUpdateDivision.salesOrganization = this.salesOrganizationList.find(
        (sales) => sales._id.toString() === salesId
      )!;
    }
  }


  clearFilters(): void {
    this.selectedCompanyIds = [];
    this.searchQuery = "";
    this.form.reset({ companyId: null });
    this.findAllWithCount();
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
